import { Typography } from '@material-ui/core';
import { ConfirmDialog } from 'shared/ui/ConfirmDialog';
import { trackSuperPayEvent } from '../../data/SuperPayAnalytics';

interface ScreenshotCheckDialogProps {
  open: boolean;
  onKeepWaiting: () => void;
  onClose: () => void;
}

export function ScreenshotCheckDialog({
  open,
  onKeepWaiting,
  onClose,
}: ScreenshotCheckDialogProps) {
  function handleChoice(choice: 'keep_waiting' | 'close' | 'dismissed') {
    trackSuperPayEvent({
      name: 'Carrier Closed Screenshot Check Dialog',
      choice,
    });

    if (choice === 'close') {
      onClose();
    } else {
      onKeepWaiting();
    }
  }

  return (
    <ConfirmDialog
      open={open}
      title="We’re still checking your screenshot"
      onClose={() => handleChoice('dismissed')}
      cancelButtonProps={{
        children: 'Keep waiting',
        onClick: () => handleChoice('keep_waiting'),
      }}
      confirmButtonProps={{
        children: 'Close',
        onClick: () => handleChoice('close'),
      }}
    >
      <Typography>
        You can close this. We’ll finish checking and update your bank account.
        It usually takes a few seconds.
      </Typography>
    </ConfirmDialog>
  );
}
